import OperationWrapper from './operation/OperationWrapper';
import { Grid, Message, Header, List, Icon, Segment, Image } from 'semantic-ui-react'
import hikvisionLogo from '../../resources/logo.png'

const Registered = ({ user }) => {

    const getRegistrationDetails = () => {
        const registrationDetails = [];

        (user?.firstName && user?.lastName) && registrationDetails.push({ key: 'Name', value: user.firstName + " " + user.lastName, icon: 'user' })
        user?.email && registrationDetails.push({ key: 'Registered Email', value: user.email, icon: 'mail' })
        user?.contactNumber && registrationDetails.push({ key: 'Contact Number', value: user.contactNumber, icon: 'phone' })
        user?.companyID?.companyName && registrationDetails.push({ key: 'Company Name', value: user.companyID.companyName, icon: 'building outline' })
        user?.country?.text && registrationDetails.push({ key: 'Country', value: user.country.text, icon: 'world' })

        return registrationDetails;
    }

    return (
        <>
            {
                user.approved ?
                    <OperationWrapper />
                    :
                    <Grid centered columns={3} padded>
                        <Message info style={{ marginTop: '40px' }}>
                            <Message.Header>Your registraion is pending for the approval.</Message.Header>
                            <p>Registrations are usually approved within 2 weeks. If you do not receive approval within that time, please email support@hikportal.com.</p>
                        </Message>
                    </Grid>
            }


            <Grid stackable textAlign='center' centered verticalAlign='bottom'>
                <Grid.Row>
                    <Grid.Column textAlign='center'>
                        <Message info>
                            <Header as='h2'>Registration Details</Header>


                            <List horizontal>
                                {
                                    getRegistrationDetails().map(companyDetail => {
                                        return (
                                            <List.Item as='a' key={companyDetail.key}>
                                                <Icon name={companyDetail.icon} />
                                                <List.Content>
                                                    <List.Header>{companyDetail.key}</List.Header>
                                                    <List.Description>
                                                        {companyDetail.value}
                                                    </List.Description>
                                                </List.Content>
                                            </List.Item>
                                        )
                                    })
                                }
                            </List>
                        </Message>
                        <Header as='h3' >
                            If there are any changes to above details
                            <Header.Subheader>
                                Please send us an email to support@hikportal.com notifying the changes
                            </Header.Subheader>
                        </Header>
                        <Segment basic textAlign="center">
                            <Image size='small' src={hikvisionLogo} centered />
                            <p style={{ color: 'grey', marginTop: '5px' }}>©2023 - Hik-Partner Link. Hikvision South Asia.</p>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    )
}

export default Registered;